import { render, staticRenderFns } from "./ServiceOrderOptionsSummary.vue?vue&type=template&id=0af11843&scoped=true&"
import script from "./ServiceOrderOptionsSummary.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderOptionsSummary.vue?vue&type=script&lang=js&"
import style0 from "./ServiceOrderOptionsSummary.vue?vue&type=style&index=0&id=0af11843&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af11843",
  null
  
)

export default component.exports